import React from 'react'
import { Trans } from '@lingui/react'
import { UserAvatar } from 'client/shared/blocks/user-avatar'
import Spacer from 'client/shared/blocks/spacer'
import { CurrentUserState } from 'client/shared/types/current-user'
import { Product, ProductPlan } from 'client/shared/types/subscription'
import subscriptionHelper from 'client/shared/helpers/subscription-helper'

import '../subscription/subscription.styl'

export const TrialUnavailableHeader = (props: {
  isMobileSize: boolean
  user: CurrentUserState
  currentPlan: ProductPlan | Product
  cardUsedBefore?: boolean
}): JSX.Element => {
  const { user, currentPlan, isMobileSize, cardUsedBefore = false } = props
  const { currency, price } = currentPlan

  const readablePrice = subscriptionHelper.readablePrice({
    locale: user.data.locale,
    currency,
    price,
  })

  return (
    <>
      <Spacer size={isMobileSize ? 40 : 64} />
      <div className="trial-unavailable-header__wrapper">
        <UserAvatar user={user.data} size={24} />
        <Spacer size={8} />
        <span className="trial-unavailable-header__title">
          <Trans
            id="subscription.trial_unavailable"
            values={{
              username: user.data.login,
              price: readablePrice,
            }}
            components={[<br />]}
          />
        </span>
        <Spacer size={8} />
        <span className="trial-unavailable-header__description">
          <Trans
            id={`subscription.${
              cardUsedBefore
                ? 'trial_unavailable_card_used'
                : 'trial_unavailable_description'
            }`}
            values={{
              price: readablePrice,
            }}
          />
        </span>
      </div>
    </>
  )
}
